import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  FiHome, 
  FiFileText, 
  FiMessageSquare, 
  FiBarChart2,
  FiMenu,
  FiX
} from 'react-icons/fi';
import './Layout.css';

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const location = useLocation();

  const menuItems = [
    { path: '/', icon: FiHome, label: 'Dashboard' },
    { path: '/demandes', icon: FiFileText, label: 'Demandes Clients' },
    { path: '/discussions', icon: FiMessageSquare, label: 'Discussions' },
    { path: '/statistiques', icon: FiBarChart2, label: 'Statistiques' },
  ];

  return (
    <div className="layout">
      <div className={`sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <h2>Panel Admin</h2>
          <button 
            className="toggle-sidebar"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            {sidebarOpen ? <FiX /> : <FiMenu />}
          </button>
        </div>
        <nav className="sidebar-nav">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-item ${isActive ? 'active' : ''}`}
                onClick={() => {
                  // Fermer le sidebar sur mobile après avoir cliqué sur un lien
                  if (window.innerWidth <= 768) {
                    setSidebarOpen(false);
                  }
                }}
              >
                <Icon />
                {sidebarOpen && <span>{item.label}</span>}
              </Link>
            );
          })}
        </nav>
      </div>
      <div className="main-content">
        <header className="header">
          <div className="header-left">
            <button 
              className="mobile-menu-btn"
              onClick={() => setSidebarOpen(!sidebarOpen)}
            >
              <FiMenu />
            </button>
            <h1>Panel d'Administration</h1>
          </div>
          <div className="header-right">
            <div className="user-info">
              <div className="user-avatar">
                {(() => {
                  const userStr = localStorage.getItem('user');
                  if (userStr) {
                    try {
                      const user = JSON.parse(userStr);
                      return `${user.prenom[0]}${user.nom[0]}`.toUpperCase();
                    } catch (e) {
                      return 'GT';
                    }
                  }
                  return 'GT';
                })()}
              </div>
              <span>
                {(() => {
                  const userStr = localStorage.getItem('user');
                  if (userStr) {
                    try {
                      const user = JSON.parse(userStr);
                      return `${user.prenom} ${user.nom}`;
                    } catch (e) {
                      return 'Gauthier Thery';
                    }
                  }
                  return 'Gauthier Thery';
                })()}
              </span>
              <button 
                className="logout-button"
                onClick={() => {
                  localStorage.removeItem('user');
                  localStorage.removeItem('authenticated');
                  window.location.href = '/login';
                }}
                title="Déconnexion"
              >
                Déconnexion
              </button>
            </div>
          </div>
        </header>
        <div className="content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;

